module.exports = __webpack_public_path__ + "static/img/copper-sheet_256.ffe974b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/copper-sheet_256.png
// module id = iMnS
// module chunks = 0